import { createActions } from 'utils/actions';

/**
 * Subscribe to presence updates for a specific case.
 * Payload: { caseId }
 */
export const subscribeCasePresence = createActions('casePresence', 'SUBSCRIBE_CASE_PRESENCE', {
    asPromise: true,
});

/**
 * Unsubscribe from presence updates for a specific case.
 * Payload: { caseId }
 */
export const unsubscribeCasePresence = createActions('casePresence', 'UNSUBSCRIBE_CASE_PRESENCE', {
    asPromise: true,
});

/**
 * Update the viewers list for a specific case (dispatched when
 * a broadcast message is received from the TicketActivityChannel).
 * Payload: { caseId, viewers }
 */
export const updateCaseViewers = createActions('casePresence', 'UPDATE_CASE_VIEWERS');

/**
 * Clear presence data for a specific case from the store.
 * Payload: { caseId }
 */
export const clearCasePresence = createActions('casePresence', 'CLEAR_CASE_PRESENCE');
